import styled from 'styled-components';
import { Input as AntInput } from '@vertem-core/vertice-ds';
import MaskedInput from 'antd-mask-input';

export const paddingResponsive = '40px';

export interface StyledLabelProps {
  $isFocused: boolean;
  $hasValue: boolean;
}

export const InputWrapper = styled.div`
  position: relative;
`;

export const StyledLabel = styled.label<StyledLabelProps>`
  position: absolute;
  top: ${(props) => (props.$isFocused || props.$hasValue ? '8px' : '53%')};
  left: ${paddingResponsive};
  transform: translateY(
    ${(props) => (props.$isFocused || props.$hasValue ? '0%' : '-50%')}
  );
  font-size: ${(props) =>
    props.$isFocused || props.$hasValue ? '12px' : '16px'};
  color: ${(props) =>
    props.$isFocused ? 'var(--colorTextInput)' : 'var(--colorTextPlaceholder)'};
  transition: all 0.3s ease;
  pointer-events: none;
  z-index: 999;
`;

export const StyledInput = styled(AntInput)`
  padding: 20px ${paddingResponsive} 8px ${paddingResponsive};
  height: var(--inputHeight-fml, 48px) !important;

  &:disabled {
    color: #333 !important;
    background-color: var(--color-input-background-disabled) !important;
    border-color: var(--color-input-border) !important;
    opacity: 1 !important;
  }

  &.ant-input-disabled {
    color: #333 !important;
    background-color: var(--color-input-background-disabled) !important;
    border-color: var(--color-input-border) !important;
    opacity: 1 !important;
  }

  &.ant-input-disabled input {
    color: #333 !important;
    background-color: var(--color-input-background-disabled) !important;
    border-color: var(--color-input-border) !important;
    opacity: 1 !important;
  }

  &.ant-input-outlined {
    background-color: var(--color-input-background) !important;
  }

  &.ant-input-outlined.ant-input-disabled {
    background-color: var(--color-input-background-disabled) !important;
  }
`;

export const StyledMaskedInput = styled(MaskedInput)<{
  isFocused: boolean;
  hasValue: boolean;
}>`
  padding: 20px ${paddingResponsive} 8px ${paddingResponsive};
  height: var(--inputHeight-fml, 48px) !important;
  border-radius: var(--borderRadiusInput) !important;
  border: 1px solid var(--color-input-border) !important;
  background-color: var(--color-input-background) !important;
  color: ${(props) =>
    props.isFocused || props.hasValue
      ? 'var(--colorTextInput)'
      : 'transparent'} !important;
  transition: color 0.3s ease;

  &:disabled {
    color: #333 !important;
    background-color: var(--color-input-background-disabled) !important;
    border-color: var(--color-input-border) !important;
  }
`;

export const LoaderWrapper = styled.div`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;
`;

export const SpinStyle = {
  marginRight: '5px'
};

